import React, { useState, useEffect } from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import { EMPTY_OBJECT } from './AddTaskList'

function ProcessUpdateCube(props) {
    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [sqLDbList, setSqLDbList] = useState([])
    const [ssasServers, setSsasServers] = useState([])
    const [selectedSsasServer, setSelectedSsasServer] = useState(-1)
    const [ssasDataSources, setSsasDataSources] = useState([])
    const [selectedSsasDataSource, setSelectedSsasDataSource] = useState('')

    // trigger on component mount
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 0)
            setSqLDbList(dBList)
        }

        if (ssasServers.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 1)
            setSsasServers(dBList)
        }
    }, [])

    useEffect(() => {
        if (props.taskData.databaseId !== -1) {
            if (props.taskData.databaseId !== selectedSsasServer) {
                setIsLoadingRequest(true)
                setSelectedSsasServer(props.taskData.databaseId)

                let getDataSources = props.getDataSources(props.taskData.databaseId)
                getDataSources.then((resp) => { 
                    if (resp.status !== 200) {
                        throw new Error(resp)
                    } else {
                        return resp.json()
                    }
                }).then((json) => {
                    setIsLoadingRequest(false)
                    setSsasDataSources(json)
                    setSelectedSsasDataSource(props.taskData.dataSourceName)
                }).catch((ex) => {
                    console.error(ex)
                    setIsLoadingRequest(false)
                    setSsasDataSources([])
                })
            }
        }  else {
            setSelectedSsasServer(-1)
            setSelectedSsasDataSource('')
        }
    }, [props.taskData.databaseId, props.taskData.dataSourceName])

    function handleSsasServer(event) {
        event.preventDefault()
        setIsLoadingRequest(true)
        setSelectedSsasServer(event.target.value)

        let getDataSources = props.getDataSources(event.target.value)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            setIsLoadingRequest(false)
            setSsasDataSources(json)
        }).catch((ex) => {
            console.error(ex)
            setIsLoadingRequest(false)
            setSsasDataSources([])
        })

        fireOnSaveEvent(event.target.value, '')
    }

    function handleSsasDataSourceChange(event) {
        event.preventDefault()
        setSelectedSsasDataSource(event.target.value)
        fireOnSaveEvent(selectedSsasServer, event.target.value)
    }

    /**
     * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} dbId - Selected database ID
     * @param {string} dbName - Selected name of the database
     */
    function fireOnSaveEvent(dbId, dbName) {
        if (props.onSave) {
            let copied = JSON.parse(JSON.stringify(EMPTY_OBJECT))
            copied["databaseId"] = dbId
            copied["dataSourceName"] = dbName
            props.onSave(copied)
        }
    }

    // This is the render logic, no need to declare another method is a functional component
    return (
        <Paper elevation={3} className="dbFunctionsPaper">
            <h3>Process Cube</h3>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-ssas-database-server-label">SSAS Database Server</InputLabel>
                <Select
                    labelId="select-ssas-database-server-label"
                    id="select-ssas-database-server"
                    label="SSAS Database Server"
                    onChange={handleSsasServer}
                    defaultValue={ssasServers.length > 0 ? ssasServers[0].id : -1}
                    value={selectedSsasServer}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={-1}>Select SSAS Database Server</MenuItem>
                        { ssasServers.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-ssas-database-label">SSAS Cube</InputLabel>
                <Select
                    labelId="select-ssas-database-label"
                    id="select-ssas-database"
                    label="Select SSAS Data Source"
                    onChange={handleSsasDataSourceChange}
                    value={selectedSsasDataSource}
                    defaultValue={''}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={''}>Select SSAS Data Source</MenuItem>
                        { ssasDataSources.map((x) => x && <MenuItem key={x.value} value={x.value}>{x.value}</MenuItem>) }
                </Select>
            </FormControl>
        </Paper>
    )
}

export default ProcessUpdateCube